/// <reference path="../../../teva/resources/resources.ts" />
/* This file is auto-generated by a tool */

namespace OfficeGuy {
    export class Resources {
        static GetString(Category, Name): string {
            try {
                return Resources.LocalizedStrings[Teva.Resources.CurrentCulture][Category][Name];
            }
            catch (e) {
                console.log("String not found: " + Category + ", " + Name);
                return Name;
            }
        }

        static LocalizedStrings =
		{
			"he": { 
				"Modal": { 
					"Approve": 'אישור',
					"Cancel": 'ביטול',
					"Close": 'סגירה',
					"Submit": 'אישור'
				},
				"Website": { 
					"LanguageChange_Message": '<div style="direction:rtl;">המערכת פותחה בשפה העברית ותומכת בעברית בצורה מלאה.<br />האנגלית והערבית במערכת עדיין בבטא, ניתן להשתמש בהן, אבל עדיין ישנם תרגומים חסרים.<br />ניתן לשלוח הצעות לתרגום לכתובת support@sumit.co.il</div><br /><div style="direction="ltr">The system was developed in Hebrew and fully supports Hebrew.<br />English, Arabic and Spanish are supported, yet considered as beta. It\'s usable, but there are still some missing translations around the system.<br />Translations proposals can be sent to support@sumit.co.il</div>',
					"LanguageChange_Title": 'Language Change'
				},
				"Accounting": { 
					"Discount": 'הנחה',
					"PaymentAmount": 'סכום תשלום',
					"Price": 'מחיר',
					"Rounding": 'עיגול',
					"Save_Books": 'שמירה כמסמך סופי',
					"Save_Description": 'אפשר לשמור את המסמך כמסמך סופי?<br /><br />מסמך סופי הוא מסמך סגור שאי אפשר לערוך יותר.<br />בשביל לאפשר עריכה נוספת, יש לשמור את המסמך כטיוטה.',
					"Save_Draft": 'שמירה כטיוטה',
					"Save_Title": 'שמירת מסמך',
					"Total": 'סה"כ',
					"VAT": 'מע"מ',
					"VATIncludedOption_Included": 'אחרי מע"מ (מע"מ כלול במחיר)',
					"VATIncludedOption_NotIncluded": 'לפני מע"מ (מע"מ בנוסף למחיר)'
				},
				"CRM": { 
					"AddFieldToFolder": 'הוספת שדה לתיקייה',
					"ArchiveCommand": 'מחיקה לארכיון',
					"Cancel": 'ביטול',
					"CancelDocument": 'ביטול מסמך',
					"CancelEdit": 'ביטול עריכה',
					"Card": 'כרטיס',
					"CellSummary_Average": 'ממוצע',
					"CellSummary_Count": 'כמות',
					"CellSummary_Maximum": 'מקסימום',
					"CellSummary_Minimum": 'מינימום',
					"CellSummary_None": '<ללא סיכום ערכים>',
					"CellSummary_Sum": 'סכום',
					"ChooseCard": 'בחירת ',
					"ChooseEntity": 'בחירת כרטיס',
					"ChooseField": 'בחירת שדה',
					"ChooseFile": 'בחירת קובץ',
					"ChooseFromList": 'בחירה מרשימה',
					"ChooseSchema": 'בחירת תיקייה',
					"Close": 'סגירה',
					"CompanyDetails": 'פרטי עסק',
					"CompanyDetails_Fill": 'הזנת פרטים',
					"CompanyDetails_Header": 'לתשומת הלב, לא הוזנו פרטי עסק לתוך המערכת. חובה להזין פרטים לפני הוצאת מסמכים רשמיים.<br /><a class="bold" href="/companies/details/">ניתן להזין את פרטי העסק בלחיצה כאן</a>.',
					"CompanyDetails_HeaderNonAccounting": 'לתשומת הלב, לא הוזנו פרטי עסק לתוך המערכת. חובה להזין פרטים לפני ביצוע פעולה זו.',
					"CompanyDetails_SaveAsDraft": 'הזנת פרטים ושמירה כטיוטה',
					"CompanyDetails_SaveWithoutFilling": 'שמירה ללא הזנת פרטים',
					"CompanyName": 'שם העסק',
					"CreateCard": 'יצירת ',
					"Date_From": 'מתאריך',
					"Date_To": 'עד תאריך',
					"DateRange": 'טווח תאריכים',
					"Delete": 'מחיקה',
					"DiscardChangesContents": 'האם ברצונך לשמור את השינויים שביצעת?',
					"DiscardChangesContinueEditing": 'חזרה לעריכה',
					"DiscardChangesExitWithoutSaving": 'יציאה ללא שמירה',
					"DiscardChangesHeader": 'יציאה מעריכה',
					"Edit": 'עריכה',
					"EntityPickerCreatePrefix": 'יצירת ',
					"Filter_Boolean_False": 'לא',
					"Filter_Boolean_True": 'כן',
					"Filters_Exists_Choose": 'בחירה',
					"Filters_Exists_False": 'ריק מערכים',
					"Filters_Exists_True": 'הוזן ערך כלשהו',
					"From": 'מ',
					"InvalidCreditCardNumber": 'מספר כרטיס האשראי שהוזן שגוי. אנא הזינו מחדש את מספר הכרטיס.',
					"LinkEntity": 'קישור כרטיס',
					"LinkFolder": 'קישור תיקייה',
					"LinkURL": 'קישור',
					"LoadAdditionalRecords": 'טעינת רשומות נוספות',
					"Menu": 'תפריט',
					"NoCardsSelected": 'לא סומנו כרטיסים',
					"NormalizeByDay": 'קיבוץ לפי יום',
					"NormalizeByHalfYear": 'קיבוץ לפי חציון',
					"NormalizeByMonth": 'קיבוץ לפי חודש',
					"NormalizeByQuarter": 'קיבוץ לפי רבעון',
					"NormalizeByYear": 'קיבוץ לפי שנה',
					"NoSchemasToRecover": 'אין תיקיות לשחזור',
					"Numeric_From": 'מ',
					"Numeric_To": 'עד',
					"PropertyPicker_Legend_Children": 'תיקייה יורשת',
					"PropertyPicker_Legend_Header": 'מקרא',
					"PropertyPicker_Legend_Hidden": 'שדה מוסתר',
					"PropertyPicker_Legend_Incoming": 'שדה מקושר',
					"PropertyPicker_Legend_Incoming_Hidden": 'שדה מקושר ומוסתר',
					"RemoveEntity": 'הסרת כרטיס',
					"RenameColumn": 'שינוי שם עמודה',
					"Save": 'שמירה',
					"SaveView_SaveAsDefault": 'שמירה כתצוגת ברירת מחדל',
					"SaveView_SaveAsDefault_Company": 'שמירה כברירת מחדל ברמת עסק',
					"SaveView_SaveAsDefault_No": 'ללא שמירה כברירת מחדל',
					"SaveView_SaveAsDefault_User": 'שמירה כברירת מחדל ברמת משתמש',
					"SchemaPicker_PlaceHolder": 'בחירת תיקייה',
					"SchemaView": 'תצוגת תיקייה',
					"Search": 'חיפוש',
					"SelectAll": 'סימון הכל',
					"SelectCards": 'סימון כרטיסים',
					"SendDocumentByEmail": 'שליחת מסמך בדוא"ל',
					"SendDocumentsByEmail": 'שליחת מסמכים בדוא"ל',
					"Shortcuts": 'קיצורי דרך',
					"Submit": 'שלח',
					"Text": 'טקסט',
					"TextSearch": 'חיפוש טקסט',
					"TimeRange": 'טווח שעות',
					"To": 'עד',
					"UnsavedWarning": 'השינויים שביצעת לא ישמרו, האם זו כוונתך?',
					"UnselectAll": 'הסרת סימון',
					"ValueRange": 'טווח ערכים',
					"ViewPicker_ChooseView": 'בחר תצוגה',
					"ViewPicker_Empty": 'אין תצוגות מחוקות בתיקייה זו',
					"ViewPicker_PlaceHolder": 'בחירת תצוגה'
				},
				"CRM_EntitiesList": { 
					"CellSummary": 'סיכום ערכים בתא',
					"ClearFilters": 'ניקוי פילטרים',
					"DependentFiltered": 'עמודה מותנית',
					"Filters": 'פילטרים',
					"HideColumn": 'הסתרה מהתצוגה',
					"RenameColumn": 'שינוי שם העמודה',
					"ShowSummaryLine": 'הצגת שורת סיכום',
					"SortAscending": 'מיון בסדר עולה',
					"SortDescending": 'מיון בסדר יורד',
					"UpdateColumn": 'עדכון ערכים בעמודה'
				},
				"RichText": { 
					"Bold": 'מודגש (Ctrl+B)',
					"CreateLink": 'היפר-קישור',
					"CustomFontSize": 'הזנה ידנית',
					"DirectionLTR": 'טקסט משמאל לימין',
					"DirectionRTL": 'טקסט מימין לשמאל',
					"FontSize": 'גודל כתב',
					"Header_1": 'כותרת 1',
					"Header_2": 'כותרת 2',
					"Header_3": 'כותרת 3',
					"Header_4": 'כותרת 4',
					"Indent": 'הגדל כניסה (Tab)',
					"InsertImage": 'הוספת תמונה',
					"InsertImageURL": 'הוספת תמונה מקישור',
					"Italic": 'נטוי (Ctrl+I)',
					"JustifyCenter": 'מרכז (Ctrl + E)',
					"JustifyFull": 'ישר לשני הצדדים (Ctrl + J)',
					"JustifyLeft": 'ישר טקסט לשמאל (Ctrl + L)',
					"JustifyRight": 'ישר טקסט לימין (Ctrl + R)',
					"Normal": 'כתב רגיל',
					"OrderedList": 'מספור',
					"Outdent": 'הקטן כניסה (Shift + Tab)',
					"Redo": 'בצע מחדש שינוי אחרון (Ctrl+Y)',
					"RemoveFormat": 'נקה עיצוב',
					"Strikethrough": 'קו חוצה',
					"TextBackgroundColor": 'צבע רקע',
					"TextColor": 'צבע כתב',
					"Underline": 'קו תחתון (Ctrl+U)',
					"Undo": 'בטל שינוי אחרון (Ctrl + Z)',
					"Unlink": 'הסר היפר-קישור',
					"UnorderedList": 'תבליטים'
				},
				"PurchasePages": { 
					"UpdatePrice_Message": 'מחיר ליחידה',
					"UpdatePrice_Title": 'עדכון מחיר ליחידה',
					"UpdateQuantity_Title": 'עדכון כמות'
				}
			},
			"en": { 
				"Modal": { 
					"Approve": 'OK',
					"Cancel": 'Cancel',
					"Close": 'Close',
					"Submit": 'OK'
				},
				"Website": { 
					"LanguageChange_Message": '<div style="direction:rtl;">המערכת פותחה בשפה העברית ותומכת בעברית בצורה מלאה.<br />האנגלית והערבית במערכת עדיין בבטא, ניתן להשתמש בהן, אבל עדיין ישנם תרגומים חסרים.<br />ניתן לשלוח הצעות לתרגום לכתובת support@sumit.co.il</div><br /><div style="direction="ltr">The system was developed in Hebrew and fully supports Hebrew.<br />English, Arabic and Spanish are supported, yet considered as beta. It\'s usable, but there are still some missing translations around the system.<br />Translations proposals can be sent to support@sumit.co.il</div>',
					"LanguageChange_Title": 'Language Change'
				},
				"Accounting": { 
					"Discount": 'Discount',
					"PaymentAmount": 'Amount',
					"Price": 'Price',
					"Rounding": 'Rounding',
					"Save_Books": 'Final document',
					"Save_Description": 'Did you finish working on this document?<br />If so, please save the document as final.<br />Otherwise, please save the document as draft, in order to allow future editing.',
					"Save_Draft": 'Draft document',
					"Save_Title": 'Save document',
					"Total": 'Total',
					"VAT": 'VAT',
					"VATIncludedOption_Included": 'אחרי מע"מ (מע"מ כלול במחיר)',
					"VATIncludedOption_NotIncluded": 'לפני מע"מ (מע"מ בנוסף למחיר)'
				},
				"CRM": { 
					"AddFieldToFolder": 'Add field to folder',
					"ArchiveCommand": 'Archive',
					"Cancel": 'Cancel',
					"CancelDocument": 'Cancel document',
					"CancelEdit": 'Cancel edit',
					"Card": 'Create card',
					"CellSummary_Average": 'Average',
					"CellSummary_Count": 'Count',
					"CellSummary_Maximum": 'Maximum',
					"CellSummary_Minimum": 'Minimum',
					"CellSummary_None": '<No summary>',
					"CellSummary_Sum": 'Sum',
					"ChooseCard": 'Choose ',
					"ChooseEntity": 'Choose card',
					"ChooseField": 'Choose field',
					"ChooseFile": 'Choose file',
					"ChooseFromList": 'Choose from a list',
					"ChooseSchema": 'Choose folder',
					"Close": 'Close',
					"CompanyDetails": 'Please note some company settings are missing. Those details are required before issuing official documents.<br /><a href="/companies/details/">Click here to fill those settings.</a>',
					"CompanyDetails_Fill": 'Company Name',
					"CompanyDetails_Header": 'Save anyway',
					"CompanyDetails_HeaderNonAccounting": 'Fill settings',
					"CompanyDetails_SaveAsDraft": 'Please note some company settings are missing. Those details are required to proceed.<br /><a href="/companies/details/">Click here to fill those settings.</a>',
					"CompanyDetails_SaveWithoutFilling": 'Fill missing settings and save as draft',
					"CompanyName": 'Organization details',
					"CreateCard": 'Create ',
					"Date_From": 'From',
					"Date_To": 'To',
					"DateRange": 'Date range',
					"Delete": 'Delete',
					"DiscardChangesContents": 'Would you like to keep your changes?',
					"DiscardChangesContinueEditing": 'Continue editing',
					"DiscardChangesExitWithoutSaving": 'Discard',
					"DiscardChangesHeader": 'Stop editing',
					"Edit": 'Edit',
					"EntityPickerCreatePrefix": 'Create ',
					"Filter_Boolean_False": 'No',
					"Filter_Boolean_True": 'Yes',
					"Filters_Exists_Choose": 'Choose',
					"Filters_Exists_False": 'Empty',
					"Filters_Exists_True": 'Has value',
					"From": 'From',
					"InvalidCreditCardNumber": 'Credit card number is incorrect. Please re-enter your card number.',
					"LinkEntity": 'Link to card',
					"LinkFolder": 'Link to folder',
					"LinkURL": 'Link',
					"LoadAdditionalRecords": 'Load additional records',
					"Menu": 'Menu',
					"NoCardsSelected": 'No cards selected',
					"NormalizeByDay": 'Group by day',
					"NormalizeByHalfYear": 'Group by half year',
					"NormalizeByMonth": 'Group by month',
					"NormalizeByQuarter": 'Group by quarter',
					"NormalizeByYear": 'Group by year',
					"NoSchemasToRecover": 'No schemas to recover',
					"Numeric_From": 'From',
					"Numeric_To": 'To',
					"PropertyPicker_Legend_Children": 'Inherited folder',
					"PropertyPicker_Legend_Header": 'Legend',
					"PropertyPicker_Legend_Hidden": 'Hidden property',
					"PropertyPicker_Legend_Incoming": 'Incoming property',
					"PropertyPicker_Legend_Incoming_Hidden": 'Incoming hidden property',
					"RemoveEntity": 'Remove card',
					"RenameColumn": 'Rename column',
					"Save": 'Save',
					"SaveView_SaveAsDefault": 'Save as default view',
					"SaveView_SaveAsDefault_Company": 'Set as default view for company',
					"SaveView_SaveAsDefault_No": 'Don\'t save as default',
					"SaveView_SaveAsDefault_User": 'Set as default view for user',
					"SchemaPicker_PlaceHolder": 'Choose folder',
					"SchemaView": 'Folder view',
					"Search": 'Search',
					"SelectAll": 'Select all',
					"SelectCards": 'Select cards',
					"SendDocumentByEmail": 'Send document by email',
					"SendDocumentsByEmail": 'Send documents by email',
					"Shortcuts": 'Shortcuts',
					"Submit": 'OK',
					"Text": 'Text',
					"TextSearch": 'Text search',
					"TimeRange": 'Time range',
					"To": 'To',
					"UnsavedWarning": 'Pending changes won\'t be saved, are you sure?',
					"UnselectAll": 'Unselect All',
					"ValueRange": 'Values range',
					"ViewPicker_ChooseView": 'Choose view',
					"ViewPicker_Empty": 'No deleted views in this schema',
					"ViewPicker_PlaceHolder": 'Choose view'
				},
				"CRM_EntitiesList": { 
					"CellSummary": 'Cell summary',
					"ClearFilters": 'Clear filters',
					"DependentFiltered": 'Dependent filtered',
					"Filters": 'Filters',
					"HideColumn": 'Hide column',
					"RenameColumn": 'Rename column',
					"ShowSummaryLine": 'Show summary',
					"SortAscending": 'Sort (ascending)',
					"SortDescending": 'Sort (descending)',
					"UpdateColumn": 'עדכון ערכים בעמודה'
				},
				"RichText": { 
					"Bold": 'Bold (Ctrl+B)',
					"CreateLink": 'Create link',
					"CustomFontSize": 'Custom',
					"DirectionLTR": 'Left to Right text',
					"DirectionRTL": 'Right to Left text',
					"FontSize": 'Font size',
					"Header_1": 'Header 1',
					"Header_2": 'Header 2',
					"Header_3": 'Header 3',
					"Header_4": 'Header 4',
					"Indent": 'Indent (Tab)',
					"InsertImage": 'Insert image',
					"InsertImageURL": 'Insert image from URL',
					"Italic": 'Italic (Ctrl+I)',
					"JustifyCenter": 'Center (Ctrl+E)',
					"JustifyFull": 'Justify full (Ctrl+J)',
					"JustifyLeft": 'Justify left (Ctrl+L)',
					"JustifyRight": 'Justify right (Ctrl+R)',
					"Normal": 'Normal',
					"OrderedList": 'Ordered list',
					"Outdent": 'Outdent (Shift+Tab)',
					"Redo": 'Redo (Ctrl+Y)',
					"RemoveFormat": 'Remove formatting',
					"Strikethrough": 'Strikethrough',
					"TextBackgroundColor": 'Background color',
					"TextColor": 'Foreground color',
					"Underline": 'Underline (Ctrl+U)',
					"Undo": 'Undo (Ctrl+Z)',
					"Unlink": 'Unlink',
					"UnorderedList": 'Unordered list'
				},
				"PurchasePages": { 
					"UpdatePrice_Message": 'Unit price',
					"UpdatePrice_Title": 'Update unit price',
					"UpdateQuantity_Title": 'Update quantity'
				}
			},
			"ar": { 
				"Modal": { 
					"Approve": 'إرسال',
					"Cancel": 'إلغاء الأمر',
					"Close": 'إغلاق',
					"Submit": 'إرسال'
				},
				"Website": { 
					"LanguageChange_Message": '<div style="direction:rtl;">המערכת פותחה בשפה העברית ותומכת בעברית בצורה מלאה.<br />האנגלית והערבית במערכת עדיין בבטא, ניתן להשתמש בהן, אבל עדיין ישנם תרגומים חסרים.<br />ניתן לשלוח הצעות לתרגום לכתובת support@sumit.co.il</div><br /><div style="direction="ltr">The system was developed in Hebrew and fully supports Hebrew.<br />English, Arabic and Spanish are supported, yet considered as beta. It\'s usable, but there are still some missing translations around the system.<br />Translations proposals can be sent to support@sumit.co.il</div>',
					"LanguageChange_Title": 'Language Change'
				},
				"Accounting": { 
					"Discount": 'خصم',
					"PaymentAmount": 'المبلغ المدفوع',
					"Price": 'الأسعار',
					"Rounding": 'دائرة',
					"Save_Books": 'الوثيقة الختامية',
					"Save_Description": 'كنت قد انتهيت من العمل على وثيقة؟ <br /> "إذا نعم"، يجب عليك حفظ المستند كنهائي، وتحميل المستند < br/> إلا إذا، يجب حفظ المستند كمسودة، وسوف تكون قادرة على تحرير المستند.',
					"Save_Draft": 'مشروع الوثيقة',
					"Save_Title": 'حفظ مستند',
					"Total": 'المجموع',
					"VAT": 'מע"מ',
					"VATIncludedOption_Included": 'אחרי מע"מ (מע"מ כלול במחיר)',
					"VATIncludedOption_NotIncluded": 'לפני מע"מ (מע"מ בנוסף למחיר)'
				},
				"CRM": { 
					"AddFieldToFolder": 'إضافة حقل إلى مجلد',
					"ArchiveCommand": 'الأرشفة',
					"Cancel": 'إلغاء الأمر',
					"CancelDocument": 'إلغاء وثيقة',
					"CancelEdit": 'إلغاء التحرير',
					"Card": 'بطاقة',
					"CellSummary_Average": 'في المتوسط',
					"CellSummary_Count": 'الكمية',
					"CellSummary_Maximum": 'ماكس',
					"CellSummary_Minimum": 'دقيقة',
					"CellSummary_None": '< دون تلخيص القيم >',
					"CellSummary_Sum": 'مجموع',
					"ChooseCard": 'تحديد ',
					"ChooseEntity": 'اختيار بطاقة',
					"ChooseField": 'حدد حقل',
					"ChooseFile": 'בחירת קובץ',
					"ChooseFromList": 'تحديد من قائمة',
					"ChooseSchema": 'تحديد مجلد',
					"Close": 'إغلاق',
					"CompanyDetails": 'تفاصيل المنظمة',
					"CompanyDetails_Fill": 'أدخل التفاصيل',
					"CompanyDetails_Header": 'الاهتمام، دخلت في نظام المعلومات في المؤسسة. يجب أن يتم إدخال التفاصيل قبل إصدار الوثائق الرسمية < br/> < فئة = "" href = "جريئة"/الشركات/التفاصيل/> يمكن إدخال تفاصيل المؤسسة الخاصة بك عن طريق النقر هنا</a>.',
					"CompanyDetails_HeaderNonAccounting": 'الاهتمام، دخلت في نظام المعلومات في المؤسسة. يجب أن يتم إدخال التفاصيل قبل تنفيذ هذه العملية. < br/> < فئة = "" href = "جريئة"/الشركات/التفاصيل/> يمكن إدخال تفاصيل المؤسسة الخاصة بك عن طريق النقر هنا</a>.',
					"CompanyDetails_SaveAsDraft": 'أدخل التفاصيل وحفظ كمسودة',
					"CompanyDetails_SaveWithoutFilling": 'الحفظ بدون الدخول في التفاصيل',
					"CompanyName": 'اسم المؤسسة',
					"CreateCard": 'إنشاء ',
					"Date_From": 'من تاريخ',
					"Date_To": 'حتى تاريخ',
					"DateRange": 'نطاق التاريخ',
					"Delete": 'حذف',
					"DiscardChangesContents": 'هل تريد حفظ التغييرات؟',
					"DiscardChangesContinueEditing": 'مرة أخرى لتحرير',
					"DiscardChangesExitWithoutSaving": 'الإنهاء بدون حفظ',
					"DiscardChangesHeader": 'إنهاء تحرير',
					"Edit": 'تحرير',
					"EntityPickerCreatePrefix": 'יצירת ',
					"Filter_Boolean_False": 'لا',
					"Filter_Boolean_True": 'نعم',
					"Filters_Exists_Choose": 'تحديد',
					"Filters_Exists_False": 'الصفائف الفارغة',
					"Filters_Exists_True": 'القيمة المدخلة',
					"From": 'من',
					"InvalidCreditCardNumber": 'מספר כרטיס האשראי שהוזן שגוי. אנא הזינו מחדש את מספר הכרטיס.',
					"LinkEntity": 'رابط التذاكر',
					"LinkFolder": 'رابط المجلد',
					"LinkURL": 'الارتباط',
					"LoadAdditionalRecords": 'تحميل سجلات إضافية',
					"Menu": 'القائمة',
					"NoCardsSelected": 'لا توجد بطاقات ملحوظ',
					"NormalizeByDay": 'مجموعة حسب اليوم',
					"NormalizeByHalfYear": 'كيبوتز بمتوسط',
					"NormalizeByMonth": 'التجميع حسب الشهر',
					"NormalizeByQuarter": 'التجميع حسب الربع',
					"NormalizeByYear": 'تجميع حسب السنة',
					"NoSchemasToRecover": 'وهناك أية مجلدات لاستعادة',
					"Numeric_From": 'من',
					"Numeric_To": 'حتى',
					"PropertyPicker_Legend_Children": 'المجلد الخلف',
					"PropertyPicker_Legend_Header": 'أسطورة',
					"PropertyPicker_Legend_Hidden": 'الحقل المخفي',
					"PropertyPicker_Legend_Incoming": 'حقل مرتبط',
					"PropertyPicker_Legend_Incoming_Hidden": 'الحقل المرتبط وخفية',
					"RemoveEntity": 'إزالة بطاقة',
					"RenameColumn": 'إعادة تسمية عمود',
					"Save": 'حفظ',
					"SaveView_SaveAsDefault": 'حفظ كطريقة العرض الافتراضية',
					"SaveView_SaveAsDefault_Company": 'الافتراضي الاحتفاظ بالمؤسسة',
					"SaveView_SaveAsDefault_No": 'دون الحفظ بشكل افتراضي',
					"SaveView_SaveAsDefault_User": 'حفظ كمستوى المستخدم الافتراضي',
					"SchemaPicker_PlaceHolder": 'تحديد مجلد',
					"SchemaView": 'عرض المجلد',
					"Search": 'البحث عن',
					"SelectAll": 'الاختيار جميع',
					"SelectCards": 'الاختيار التذاكر',
					"SendDocumentByEmail": 'إرسال مستند بالبريد الإلكتروني',
					"SendDocumentsByEmail": 'إرسال الوثائق بالبريد الإلكتروني',
					"Shortcuts": 'اختصارات',
					"Submit": 'إرسال',
					"Text": 'نص',
					"TextSearch": 'البحث عن نص',
					"TimeRange": 'مجموعة ساعات',
					"To": 'حتى',
					"UnsavedWarning": 'لن يتم حفظ التغييرات الخاصة بك، يعني؟',
					"UnselectAll": 'إزالة التمييز',
					"ValueRange": 'مجموعة من القيم',
					"ViewPicker_ChooseView": 'حدد طريقة عرض',
					"ViewPicker_Empty": 'وهناك عدم حذف هذا المجلد طرق العرض',
					"ViewPicker_PlaceHolder": 'تحديد طريقة عرض'
				},
				"CRM_EntitiesList": { 
					"CellSummary": 'تلخيص القيم في خلية',
					"ClearFilters": 'تصفية التنظيف',
					"DependentFiltered": 'العمود الشرطي',
					"Filters": 'مرشحات (فلاتر)',
					"HideColumn": 'إخفاء من العرض',
					"RenameColumn": 'إعادة تسمية عمود',
					"ShowSummaryLine": 'يعرض صف الملخص',
					"SortAscending": 'فرز تصاعدي',
					"SortDescending": 'فرز تنازلي',
					"UpdateColumn": 'עדכון ערכים בעמודה'
				},
				"RichText": { 
					"Bold": 'أسود عريض (Ctrl + B)',
					"CreateLink": 'ارتباط تشعبي',
					"CustomFontSize": 'تغذية يدوية',
					"DirectionLTR": 'טקסט משמאל לימין',
					"DirectionRTL": 'טקסט מימין לשמאל',
					"FontSize": 'حجم الرسالة',
					"Header_1": 'العنوان 1',
					"Header_2": 'العنوان 2',
					"Header_3": 'العنوان 3',
					"Header_4": 'العنوان 4',
					"Indent": 'زيادة المسافة البادئة (علامة التبويب)',
					"InsertImage": 'إضافة صورة',
					"InsertImageURL": 'إضافة ارتباط للصورة',
					"Italic": 'مائل (Ctrl + I)',
					"JustifyCenter": 'مركز (Ctrl + E)',
					"JustifyFull": 'تبرير (Ctrl + J)',
					"JustifyLeft": 'محاذاة النص إلى اليسار (Ctrl + L)',
					"JustifyRight": 'محاذاة النص لليمين (Ctrl + R)',
					"Normal": 'الرسالة القياسية',
					"OrderedList": 'الترقيم',
					"Outdent": 'إنقاص المسافة البادئة (Shift + Tab)',
					"Redo": 'إعادة التغيير الأخير (Ctrl + Y)',
					"RemoveFormat": 'مسح التنسيق',
					"Strikethrough": 'يتوسطه خط',
					"TextBackgroundColor": 'لون الخلفية',
					"TextColor": 'لون الكتابة',
					"Underline": 'تسطير (Ctrl + U)',
					"Undo": 'التراجع عن التغيير الأخير (Ctrl + Z)',
					"Unlink": 'إزالة الارتباط التشعبي',
					"UnorderedList": 'تعداد نقطي'
				},
				"PurchasePages": { 
					"UpdatePrice_Message": 'מחיר ליחידה',
					"UpdatePrice_Title": 'עדכון מחיר ליחידה',
					"UpdateQuantity_Title": 'עדכון כמות'
				}
			},
			"es": { 
				"Modal": { 
					"Approve": 'confirmación',
					"Cancel": 'cancelación',
					"Close": 'cerrado',
					"Submit": 'Enviar'
				},
				"Website": { 
					"LanguageChange_Message": '<Style Div = "dirección: LTR;">. El sistema fue desarrollado en hebreo y hebreo apoya plenamente <br />Inglés y árabe están todavía en fase beta, se pueden utilizar, pero traducciones siguen desaparecidos. <br />Puede enviar sugerencias subtitulado support@sumit.co.il </ div> <br /><Style Div = "dirección =" ltr "> El sistema fue desarrollado en hebreo y apoya plenamente hebreo. <br />Inglés, árabe y español son compatibles, sin embargo, considerarse como beta. Es útil, pero todavía hay algunas traducciones que faltan de todo el sistema. <br />Traducciones propuestas se pueden enviar a support@sumit.co.il </ div>',
					"LanguageChange_Title": 'Cambiar el idioma'
				},
				"Accounting": { 
					"Discount": 'descuento',
					"PaymentAmount": 'El monto del pago',
					"Price": 'precio',
					"Rounding": 'redondeo',
					"Save_Books": 'documento final',
					"Save_Description": '¿Terminaste trabajando en este documento? <br /> Si es así, por favor guardar el documento como final. <br /> De lo contrario, por favor guardar el documento como borrador, con el fin de permitir la edición futuro.',
					"Save_Draft": 'Borrador',
					"Save_Title": 'Guardar documento',
					"Total": 'Total',
					"VAT": 'מע"מ',
					"VATIncludedOption_Included": 'אחרי מע"מ (מע"מ כלול במחיר)',
					"VATIncludedOption_NotIncluded": 'לפני מע"מ (מע"מ בנוסף למחיר)'
				},
				"CRM": { 
					"AddFieldToFolder": 'Adición de un campo a una carpeta',
					"ArchiveCommand": 'pasar al archivo',
					"Cancel": 'Cancelar',
					"CancelDocument": 'Cancelar documento',
					"CancelEdit": 'Cancelar edición',
					"Card": 'tarjeta',
					"CellSummary_Average": 'promedio',
					"CellSummary_Count": 'cantidad',
					"CellSummary_Maximum": 'Máximo',
					"CellSummary_Minimum": 'mínimo',
					"CellSummary_None": '<No hay un resumen>',
					"CellSummary_Sum": 'importe',
					"ChooseCard": 'La elección ',
					"ChooseEntity": 'La elección de una tarjeta',
					"ChooseField": 'elegir campo',
					"ChooseFile": 'בחירת קובץ',
					"ChooseFromList": 'Elegir de una lista',
					"ChooseSchema": 'Elegir la carpeta',
					"Close": 'cerrado',
					"CompanyDetails": 'información de la organización',
					"CompanyDetails_Fill": 'nombre de empresa',
					"CompanyDetails_Header": 'Atención, no hay información organización introduce en el sistema. Debe introducir la información antes de emitir documentos oficiales. <br /> <a class="bold" href="/companies/details/"> puede entrar en los detalles de la organización haciendo clic aquí </a>.',
					"CompanyDetails_HeaderNonAccounting": 'Atención, no hay información organización introduce en el sistema. Debe introducir la información antes de realizar esta acción. <br /> <a class="bold" href="/companies/details/"> puede entrar en los detalles de la organización haciendo clic aquí </a>.',
					"CompanyDetails_SaveAsDraft": 'Detalles de entrada y Guardar como borrador',
					"CompanyDetails_SaveWithoutFilling": 'guardar sin cargar datos',
					"CompanyName": 'Nombre de la Organización',
					"CreateCard": 'Crear ',
					"Date_From": 'desde la fecha',
					"Date_To": 'hasta la fecha',
					"DateRange": 'Rango de fechas',
					"Delete": 'borrar',
					"DiscardChangesContents": '¿Quieres guardar los cambios?',
					"DiscardChangesContinueEditing": 'Continua editando',
					"DiscardChangesExitWithoutSaving": 'Salir sin guardar',
					"DiscardChangesHeader": 'salir de la edicion',
					"Edit": 'editar',
					"EntityPickerCreatePrefix": 'יצירת ',
					"Filter_Boolean_False": 'No',
					"Filter_Boolean_True": 'Sí',
					"Filters_Exists_Choose": 'seleccionar',
					"Filters_Exists_False": 'Vacío',
					"Filters_Exists_True": 'se cargo algun valor',
					"From": 'De',
					"InvalidCreditCardNumber": 'מספר כרטיס האשראי שהוזן שגוי. אנא הזינו מחדש את מספר הכרטיס.',
					"LinkEntity": 'Enlace a la tarjeta',
					"LinkFolder": 'Enlace a la carpeta',
					"LinkURL": 'enlace',
					"LoadAdditionalRecords": 'Cargar registros adicionales',
					"Menu": 'menú',
					"NoCardsSelected": 'no hay tarjetas seleccionadas',
					"NormalizeByDay": 'La agrupación por día',
					"NormalizeByHalfYear": 'agrupar por medio año',
					"NormalizeByMonth": 'La agrupación por Mes',
					"NormalizeByQuarter": 'agrupar por cuatrismestre',
					"NormalizeByYear": 'Agrupar por año',
					"NoSchemasToRecover": 'no hay carpetas para recuperar',
					"Numeric_From": 'de',
					"Numeric_To": 'hasta',
					"PropertyPicker_Legend_Children": 'carpeta heredada',
					"PropertyPicker_Legend_Header": 'Leyenda',
					"PropertyPicker_Legend_Hidden": 'Un campo oculto',
					"PropertyPicker_Legend_Incoming": 'vinculado campo',
					"PropertyPicker_Legend_Incoming_Hidden": 'campo vinculado y oculto',
					"RemoveEntity": 'remover tarjeta',
					"RenameColumn": 'Cambiar el nombre de la columna',
					"Save": 'guardar',
					"SaveView_SaveAsDefault": 'guardar como exposicion predeterminada',
					"SaveView_SaveAsDefault_Company": 'Establecer como vista predeterminada para la compañía',
					"SaveView_SaveAsDefault_No": 'No guardar como predeterminado',
					"SaveView_SaveAsDefault_User": 'Establecer como vista predeterminada para el usuario',
					"SchemaPicker_PlaceHolder": 'Selección de una carpeta',
					"SchemaView": 'Vista de carpeta',
					"Search": 'búsqueda',
					"SelectAll": 'Marcar todo',
					"SelectCards": 'Seleccione las tarjetas',
					"SendDocumentByEmail": 'Enviar el documento por correo electrónico',
					"SendDocumentsByEmail": 'Enviar documentos por correo electrónico',
					"Shortcuts": 'atajos',
					"Submit": 'Enviar',
					"Text": 'texto',
					"TextSearch": 'Búsqueda de texto',
					"TimeRange": 'rango de horas',
					"To": 'hasta',
					"UnsavedWarning": 'los cambios no se guardaran ,estas seguro?',
					"UnselectAll": 'desmarcando',
					"ValueRange": 'Rango de valores',
					"ViewPicker_ChooseView": 'Seleccione Ver',
					"ViewPicker_Empty": 'no hay exposiciones borradas en esta carpeta',
					"ViewPicker_PlaceHolder": 'Selección de pantalla'
				},
				"CRM_EntitiesList": { 
					"CellSummary": 'resumen de valores en la celula',
					"ClearFilters": 'Eliminar filtros',
					"DependentFiltered": 'columna condicional',
					"Filters": 'filtros',
					"HideColumn": 'ocultar de la exposicion',
					"RenameColumn": 'Cambiar el nombre de la columna',
					"ShowSummaryLine": 'Muestra una línea de resumen',
					"SortAscending": 'Orden ascendente',
					"SortDescending": 'Clasificar en orden descendente',
					"UpdateColumn": 'עדכון ערכים בעמודה'
				},
				"RichText": { 
					"Bold": 'remarcado )ctrl+B)',
					"CreateLink": 'hiperenlace',
					"CustomFontSize": 'alimentación manual',
					"DirectionLTR": 'טקסט משמאל לימין',
					"DirectionRTL": 'טקסט מימין לשמאל',
					"FontSize": 'Tamaño de fuente',
					"Header_1": 'Título 1',
					"Header_2": 'Título 2',
					"Header_3": 'título 3',
					"Header_4": 'titulo 4',
					"Indent": 'agrandar la entrada(tab)',
					"InsertImage": 'Añadir foto',
					"InsertImageURL": 'Insertar imagen de la URL',
					"Italic": 'Cursiva (Ctrl + I)',
					"JustifyCenter": 'Centro (Ctrl + E)',
					"JustifyFull": 'alinear ambos lados( ctrl+j)',
					"JustifyLeft": 'alinear texto a la izq. (ctrl+l)',
					"JustifyRight": 'ainear texto a la derecha(ctrl+r)',
					"Normal": 'escritura normal',
					"OrderedList": 'numeración',
					"Outdent": 'achicar entrada (shift+tab)',
					"Redo": 'Rehacer último cambio (Ctrl + Y)',
					"RemoveFormat": 'limpiar el diseño',
					"Strikethrough": 'linea divisoria',
					"TextBackgroundColor": 'color de fondo',
					"TextColor": 'color de la fuente',
					"Underline": 'Subrayado (Ctrl + U)',
					"Undo": 'Deshacer último cambio (Ctrl + Z)',
					"Unlink": 'Quitar hipervínculo',
					"UnorderedList": 'Lista desordenada'
				},
				"PurchasePages": { 
					"UpdatePrice_Message": 'מחיר ליחידה',
					"UpdatePrice_Title": 'עדכון מחיר ליחידה',
					"UpdateQuantity_Title": 'עדכון כמות'
				}
			}
		}
	}
}